import Link from "next/link";

const mapQuery = "Tähnase tee 1, Peetri alevik, 75312, Harjumaa, Eesti";
const encodedQuery = encodeURIComponent(mapQuery);
const mapIframeSrc = `https://www.google.com/maps?q=${encodedQuery}&output=embed&hl=et&z=15&iwloc=A`;
const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodedQuery}`;

export default function GoogleMapEmbed({
  title = "Meie asukoht",
  description = "Tähnase tee 1, Peetri alevik, Harjumaa, Eesti",
  className = "",
  iframeClassName = "h-[320px] md:h-[420px]",
}: {
  title?: string;
  description?: string;
  className?: string;
  iframeClassName?: string;
}) {
  return (
    <div className={`group rounded-sm border border-white/10 bg-secondary/70 overflow-hidden shadow-[0_18px_60px_rgba(0,0,0,0.28)] ${className}`}>
      <div className="border-b border-white/10 px-6 py-5">
        <p className="text-[11px] uppercase tracking-[0.2em] text-accent font-body font-semibold mb-2">
          Google Maps
        </p>
        <h3 className="font-heading font-semibold text-[22px] text-text-main">{title}</h3>
        <p className="mt-2 text-sm text-text-muted font-body">{description}</p>
      </div>

      <div className="p-3 md:p-4">
        <div className="overflow-hidden rounded-sm border border-white/10 bg-primary/70 transition-colors duration-300 group-hover:border-accent/30">
          <iframe
            title="PPF Garage asukoht Google Maps"
            src={mapIframeSrc}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
            className={`w-full ${iframeClassName} filter brightness-90 saturate-75 transition-[filter] duration-300 ease-out group-hover:brightness-100 group-hover:saturate-100`}
          />
        </div>
      </div>

      <div className="px-6 pb-6">
        <Link
          href={mapLink}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-sm font-body font-medium text-accent hover:text-accent/80 transition-colors"
        >
          Ava Google Maps
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </div>
  );
}
